module.exports = __webpack_public_path__ + "static/media/profile.a6ca1d45.png";